import { defineMessages } from 'react-intl';

export default defineMessages({
    yesterday: {
        id: 'ml.common.MLActivityDateFilter.Yesterday',
        defaultMessage: 'Yesterday'
    },
    today: {
        id: 'ml.common.MLActivityDateFilter.Today',
        defaultMessage: 'Today'
    },
    tomorrow: {
        id: 'ml.common.MLActivityDateFilter.Tomorrow',
        defaultMessage: 'Tomorrow'
    }
})